import { useState, useCallback } from 'react';

export const useDialogFullscreen = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = useCallback(() => {
    setIsFullScreen((prev) => !prev);
  }, []);

  const exitFullScreen = useCallback(() => {
    setIsFullScreen(false);
  }, []);

  return {
    isFullScreen,
    toggleFullScreen,
    exitFullScreen,
  };
};
